import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import Canonical from '../components/Canonical';

const SitemapPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Canonical url="https://ctrlp.co.in/sitemap" />
      <Header />
      
      <main className="flex-grow container mx-auto py-12 px-10 md:px-24 lg:px-36 xl:px-48">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl font-bold text-center text-gray-800 mb-12">Sitemap</h1>
        
        {/* Main Home Section */}
        <div className="mb-16">
          <div className="border-l-4 border-blue-500 pl-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-700">Home</h2>
          </div>
          <ul className="flex flex-wrap gap-x-8 gap-y-3 ml-6">
            <li>
              <Link to="/" className="text-gray-600 hover:text-blue-600 hover:underline">
                Homepage
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Core Services Section */}
        <div className="mb-16">
          <div className="border-l-4 border-blue-500 pl-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-700">Core Services</h2>
          </div>
          <ul className="flex flex-wrap gap-x-8 gap-y-3 ml-6">
            <li>
              <Link to="/get-print" className="text-gray-600 hover:text-blue-600 hover:underline">
                Get Print
              </Link>
            </li>
            {/* <li>
              <Link to="/print-bazaar" className="text-gray-600 hover:text-blue-600 hover:underline">
                Print Bazaar
              </Link>
            </li> */}
            {/* <li>
              <Link to="/spiral-binding" className="text-gray-600 hover:text-blue-600 hover:underline">
                Spiral Binding
              </Link>
            </li> */}
            <li>
              <Link to="/software" className="text-gray-600 hover:text-blue-600 hover:underline">
                Software
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Business Section */}
        <div className="mb-16">
          <div className="border-l-4 border-blue-500 pl-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-700">Business</h2>
          </div>
          <ul className="flex flex-wrap gap-x-8 gap-y-3 ml-6">
            <li>
              <Link to="/shop-registration" className="text-gray-600 hover:text-blue-600 hover:underline">
                Shop Registration
              </Link>
            </li>
            <li>
              <Link to="/ads" className="text-gray-600 hover:text-blue-600 hover:underline">
                Advertising
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Account Section */}
        <div className="mb-16">
          <div className="border-l-4 border-blue-500 pl-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-700">Account</h2>
          </div>
          <ul className="flex flex-wrap gap-x-8 gap-y-3 ml-6">
            <li>
              <Link to="/my-account" className="text-gray-600 hover:text-blue-600 hover:underline">
                My Account
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Legal Section */}
        <div className="mb-16">
          <div className="border-l-4 border-blue-500 pl-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-700">Legal</h2>
          </div>
          <ul className="flex flex-wrap gap-x-8 gap-y-3 ml-6">
            <li>
              <Link to="/privacy-policy" className="text-gray-600 hover:text-blue-600 hover:underline">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="text-gray-600 hover:text-blue-600 hover:underline">
                Terms and Conditions
              </Link>
            </li>
          </ul>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default SitemapPage;
